import { TabsProps } from "antd";
import { filterMenuItemsWithAuth } from "components/layout/Navigation/utils";
import { ROUTE_PATHS } from "const/paths";
import { useUserContext } from "contexts/UserContext";
import { useMemo } from "react";
import { useIntl } from "react-intl";

export const useSettingsTabs = ({
  children,
}: React.PropsWithChildren): NonNullable<TabsProps["items"]> => {
  const intl = useIntl();
  const { user } = useUserContext();
  const { userPermissions = [], venuePermissions = [] } = user || {};

  return useMemo(
    () =>
      filterMenuItemsWithAuth(
        [
          {
            label: intl.formatMessage({
              defaultMessage: "Manage Users",
            }),
            key: ROUTE_PATHS.SettingsVenueUserList,
            children,
          },
          {
            label: intl.formatMessage({
              defaultMessage: "Manage Super Users",
            }),
            key: ROUTE_PATHS.SettingsUsers,
            children,
          },
          {
            label: intl.formatMessage({
              defaultMessage: "Payment Settings",
            }),
            key: ROUTE_PATHS.SettingsPayments,
            children,
          },
          {
            label: intl.formatMessage({
              defaultMessage: "Payment Terminals",
            }),
            key: ROUTE_PATHS.PaymentTerminalsList,
            children,
          },
          {
            label: intl.formatMessage({
              defaultMessage: "Widget Embed",
            }),
            key: ROUTE_PATHS.Embed,
            children,
          },
        ],
        [...userPermissions, ...venuePermissions]
      ),
    [children, intl, userPermissions, venuePermissions]
  );
};
